export function getUserRoles(user) {
  if (user) {
    return user[process.env.REACT_APP_AUTH0_AUDIENCE + "/roles"];
  }
  return [];
}
